export default "__VITE_ASSET__ByQecmuO__"